module.exports = __webpack_public_path__ + "img/icon-question-rating-like-active.85e663c8.svg";